import { render, staticRenderFns } from "./reviewWidgetAllNew.vue?vue&type=template&id=5f0bd4bb&"
import script from "./reviewWidgetAllNew.vue?vue&type=script&lang=js&"
export * from "./reviewWidgetAllNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/vasile_cyt/Documents/plentyDevTool/25996/21/reviewWidget/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f0bd4bb')) {
      api.createRecord('5f0bd4bb', component.options)
    } else {
      api.reload('5f0bd4bb', component.options)
    }
    module.hot.accept("./reviewWidgetAllNew.vue?vue&type=template&id=5f0bd4bb&", function () {
      api.rerender('5f0bd4bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/components/reviewWidgetAllNew.vue"
export default component.exports